export default "__VITE_ASSET__28ae3db1__"